import { BASE_STOREFRONT_ENDPOINT } from '../storeEndpoint'

export const INVOICE_ORDERS_ENDPOINT = `${BASE_STOREFRONT_ENDPOINT}/invoice`
